import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, onUnmounted } from 'vue';
import IconButton from '../common/IconButton.vue';
import { setFullScreen, exitFullScreen } from '../../utils/utils';
import { ICON_NAME } from '../../../constants/icon';
import { useBasicStore} from '../../../stores/basic';



export default /*#__PURE__*/_defineComponent({
  __name: 'FullScreenControl',
  setup(__props) {

const basicStore = useBasicStore();
//const isFullScreen = computed(()=>$store.state.allScreen)

// 当前是否为全屏状态, 默认为 false
// const isFullScreen = ref();
const isFullScreen=basicStore.setisallScreen
const title = computed((): string => (isFullScreen.value ? '退出全屏' : '全屏'));
const iconName = computed((): string => (isFullScreen.value ?  ICON_NAME.ExitFullScreen : ICON_NAME.FullScreen));

function toggleScreen() {
  if (isFullScreen.value) {
    exitFullScreen();
    basicStore.setisallScreen(true)
  } else  {
    const roomContainer = document.getElementById('roomContainer');
    roomContainer && setFullScreen(roomContainer);
    basicStore.setisallScreen(false)
  }
}

function handleFullScreenChange() {
  isFullScreen.value = !isFullScreen.value;
}

onMounted(() => {
  document.addEventListener('fullscreenchange', handleFullScreenChange);
});

onUnmounted(() => {
  document.removeEventListener('fullscreenchange', handleFullScreenChange);
});

return { __sfc: true,basicStore, isFullScreen, title, iconName, toggleScreen, handleFullScreenChange }
}

})